import { render, staticRenderFns } from "./segment-tab.vue?vue&type=template&id=ce180958&scoped=true&"
import script from "./segment-tab.vue?vue&type=script&lang=ts&"
export * from "./segment-tab.vue?vue&type=script&lang=ts&"
import style0 from "./segment-tab.vue?vue&type=style&index=0&id=ce180958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce180958",
  null
  
)

export default component.exports